// extracted by mini-css-extract-plugin
module.exports = {"section":"index_section_1X6Lx","holder":"index_holder_CfQJD","holder-exist":"index_holder-exist_23aF-","holder-active":"index_holder-active_AaUsM"};